export const NOT_REPORTED = 1
export const REPORTED = 2

export const types = {
  [NOT_REPORTED]: 'Orapporterade',
  [REPORTED]: 'Rapporterade'
}